import { render, staticRenderFns } from "./FieldWashTag.vue?vue&type=template&id=71d4a7e3&"
import script from "./FieldWashTag.vue?vue&type=script&lang=ts&"
export * from "./FieldWashTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports